import React from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  return (
    <footer className="relative bg-[#002D5C] overflow-hidden">

      {/* Decorative top accent line */}
      <div className="h-[2px] w-full bg-gradient-to-r from-transparent via-[#4A9FE0] to-transparent" />

      {/* Subtle background glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -left-10 -bottom-10 w-40 h-40 rounded-full bg-[#004080]/40 blur-2xl" />
        <div className="absolute right-5 -top-5 w-32 h-32 rounded-full bg-[#1B6FBB]/30 blur-xl" />
      </div>

      {/* Single compact row */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 py-3 flex flex-col sm:flex-row items-center justify-between gap-2">

        {/* Brand + website */}
        <div className="flex items-center gap-3">
          <span className="text-white font-semibold text-sm tracking-wide">
            Leeford Healthcare Ltd.
          </span>
          <span className="text-white/20 text-xs">|</span>
          <a
            href="https://www.leeford.in/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#7BBDE8] text-xs hover:text-white transition-colors duration-200 flex items-center gap-1 group"
          >
            <svg className="w-3 h-3 opacity-60 group-hover:opacity-100 transition-opacity" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
            www.leeford.in
          </a>
        </div>

        {/* Right side: Privacy Policy + Copyright */}
        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate("/policy/privacy-policy")}
            className="group flex items-center gap-1 text-[#A8C8E8] hover:text-white text-xs px-2 py-1 rounded hover:bg-white/10 transition-all duration-200 cursor-pointer bg-transparent border-none outline-none"
          >
            <svg className="w-3 h-3 opacity-60 group-hover:opacity-100 transition-opacity shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
            Privacy Policy
          </button>
          <span className="text-white/20 text-xs">|</span>
          <p className="text-[#6A9DC0] text-xs">
            &copy; {currentYear} All Rights Reserved.
          </p>
        </div>

      </div>

    </footer>
  );
};

export default Footer;